import { combineReducers } from 'redux';
import activityReducer from './activity/activityReducer';
import alertReducer from './alert/alertReducer';
import analyticsReducer from './analytics/analyticsReducer';
import carePlanReducer from './carePlan/carePlanReducer';
import caregiverAssistantReducer from './caregiverAssistant/caregiverAssistantReducer';
import chatReducer from './chat/chatReducer';
import clientDeviceReducer from './clientDevice/clientDeviceReducer';
import clinicalReducer from './clinical/clinicalReducer';
import contentReducer from './content/contentReducer';
import deviceReducer from './device/deviceReducer';
import inboxMessagesReducer from './inboxMessages/inboxMessagesReducer';
import llmPromptsReducer from './llmPrompts/llmPromptsReducer';
import oauthReducer from './oauth/oauthReducer';
import organizationReducer from './organization/organizationReducer';
import paymentReducer from './payment/paymentReducer';
import personReducer from './person/personReducer';
import promptReducer from './prompts/promptsReducer';
import sleepScheduleReducer from './sleepschedule/sleepScheduleReducer';
import tasksReducer from './tasks/tasksReducer';

export const rootReducer = combineReducers({
  activity: activityReducer,
  analytics: analyticsReducer,
  carePlan: carePlanReducer,
  caregiverAssistant: caregiverAssistantReducer,
  clinical: clinicalReducer,
  chat: chatReducer,
  clientDevice: clientDeviceReducer,
  device: deviceReducer,
  oauth: oauthReducer,
  person: personReducer,
  content: contentReducer,
  payment: paymentReducer,
  sleepSchedule: sleepScheduleReducer,
  organization: organizationReducer,
  tasks: tasksReducer,
  inboxMessages: inboxMessagesReducer,
  alert: alertReducer,
  prompts: promptReducer,
  llmPrompts: llmPromptsReducer
});
